import { RootState } from '../../../base';

export const emailTemplatesSelectors = {
    getAllTemplates: (state: RootState) => state.emailTemplates.templates,
    getCurrentPage: (state: RootState) => state.emailTemplates.currentPage,
    getPageSize: (state: RootState) => state.emailTemplates.pageSize,
    getTotalPages: (state: RootState) => state.emailTemplates.totalPages,
    getTotalCount: (state: RootState) => state.emailTemplates.totalCount,
    getSearch: (state: RootState) => state.emailTemplates.search,
    getFilters: (state: RootState) => state.emailTemplates.filters,
    getEditorOpen: (state: RootState) => state.emailTemplates.editorOpen,
    getEditorTemplate: (state: RootState) =>
        state.emailTemplates.editorTemplate,
    getIsLoadingTemplates: (state: RootState) =>
        state.emailTemplates.uiState.isLoadingTemplates,
    getIsSavingTemplate: (state: RootState) =>
        state.emailTemplates.uiState.isSavingTemplate,
    getIsDeletingTemplate: (state: RootState) =>
        state.emailTemplates.uiState.isDeletingTemplate,
    getPickerOptions: (state: RootState) => state.emailTemplates.picker.options,
    getRenderedTemplate: (state: RootState) =>
        state.emailTemplates.picker.rendered,
    getIsLoadingPickerOptions: (state: RootState) =>
        state.emailTemplates.picker.isLoading,
    getIsApplyingTemplate: (state: RootState) =>
        state.emailTemplates.picker.isApplying,
};
